import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import packages from '../package.json';
import './reset.scss';

console.log(`Tktine version: v${packages.version}`);
createApp(App).use(store).use(router).mount('#app');
